<script setup>
import { computed } from "vue";
import { Slot } from "reka-ui";
import { useFormField } from "./useFormField";

const { error, formItemId, formDescriptionId, formMessageId } = useFormField();

const hasError = computed(() => error.value !== undefined);
</script>

<template>
  <Slot
    :id="formItemId"
    :aria-describedby="
      hasError ? `${formDescriptionId} ${formMessageId}` : formDescriptionId
    "
    :aria-invalid="hasError"
  >
    <slot />
  </Slot>
</template>
